import { render, staticRenderFns } from "./TemplateDataPage.vue?vue&type=template&id=8f61b54a"
import script from "./TemplateDataPage.vue?vue&type=script&lang=js"
export * from "./TemplateDataPage.vue?vue&type=script&lang=js"
import style0 from "./TemplateDataPage.vue?vue&type=style&index=0&id=8f61b54a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports